module.exports = __webpack_public_path__ + "static/Swft-7c16610af479000cea535f7a18795612.png";